import { GanttRoot } from "./gantt";
import { GanttBaseline } from "./parts/baseline";

export type {
  GanttBaselineProps,
  GanttClassNames,
  GanttColumn,
  GanttGrid,
  GanttGroup,
  GanttHeaderRow,
  GanttIsoDate,
  GanttLimitMarker,
  GanttMarker,
  GanttPosition,
  GanttProps,
  GanttRange,
  GanttRow,
  GanttRowActions,
  GanttScale,
  GanttScaleBand,
  GanttStartMarker,
  GanttUnit,
} from "./types-gantt";
export { GANTT_TOOLTIP_ATTRIBUTE } from "./gantt.constants";
export {
  buildGanttScale,
  lanesMinHeightRem,
  positionDate,
  positionRange,
  positionToday,
  rangeToSpan,
  scaleUnits,
  toDayNumber,
} from "./gantt-scale";
export type { BuildGanttScaleOptions } from "./gantt-scale";

/** Base dos Gantts do Hub (`Gantt.Root`) e a linha de base do Planejado (`Gantt.Baseline`). */
export const Gantt = { Root: GanttRoot, Baseline: GanttBaseline };
